<template>
  <div id="manage-email-checklist">
    <site-search-group class="mar-b-20"
                       v-model.trim="params.keyword"
                       placeholder="Search by email, name or note"
                       @search="getList()"
                       @clear="handleClear" />
    <div class="ipub-tab-list mar-b-20">
      <template v-for="(item, index) in menus">
        <div v-if="user.codeList&&user.codeList.includes(item.code)"
             style="min-width:270px"
             :class="['ipub-tab-list--tab',params.type===item.key?'active':'']"
             :key="item.key">
          <a @click="changeType(item.key, index)">{{item.name}} ({{count[item.num]}})</a>
          <ipub-tooltip placement="bottomLeft"
                        type="dark"
                        style="text-align:left"
                        class="mar-l-10">
            <div slot="title">{{item.tooltip}}</div>
            <ipub-icon type="iconInfo" />
          </ipub-tooltip>
        </div>
      </template>
    </div>
    <div class="mar-b-10 ipub-p1"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.MAIL.CHECKLIST.PUBLISHER_BLACKLIST.ADD')&&params.type==='PUBLISHER_BLACKLIST'">
      <ipub-button type="primary"
                   @click="add(params.type)">
        <ipub-icon type="iconAdd" />
        Add Email into List
      </ipub-button>
    </div>
    <div class="mar-b-10 relative"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.MAIL.CHECKLIST.REVIEWER_UNSUBSCRIBE.ADD')&&params.type==='REVIEWER_UNSUBSCRIBE'">
      <ipub-select v-model="params.journalId"
                   style="width:300px"
                   clear
                   @change="getList()"
                   placeholder="Select Journal"
                   :options="journalList" />
      <div class="right-option ipub-p1">
        <ipub-button type="primary"
                     @click="add(params.type)">
          <ipub-icon type="iconAdd" />
          Add Email into List
        </ipub-button>
      </div>
    </div>
    <template v-if="this.params.type">
      <ipub-table :columns="columns[this.params.type]"
                  fixed
                  @order="onOrderChanage"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:roles="{ text }">
          <ipub-tooltip v-if="text&&text.length"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.map((item)=>{return `${item.journal?item.journal.name+' ':''}${item.name}`}).join(', ')}`" />
          <template v-else>- -</template>
        </template>
        <template v-slot:journal="{ text }">{{text&&text.name||'--'}}</template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes(menus[index].code+'.EDIT')&&['PUBLISHER_BLACKLIST', 'REVIEWER_UNSUBSCRIBE'].includes(params.type)"
                        placement="bottomLeft"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon @click="edit(record)"
                       type="iconEdit" />
          </ipub-tooltip>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes(menus[index].code+'.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </template>
    <Add :isVisable="isVisable"
         :inputData="inputData"
         :journalList="journalList"
         :type="this.params.type"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
